import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from './api';

export const useAuthUser = () => {
  const location = useLocation();
  const [state, setState] = useState(
    location.state?.user
      ? { status: 'signed-in', user: location.state.user }
      : { status: 'checking', user: null }
  );

  useEffect(() => {
    if (location.state?.user) return undefined;
    let active = true;
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then(({ data }) => {
        if (active) setState({ status: 'signed-in', user: data.user });
      })
      .catch(() => {
        if (active) setState({ status: 'signed-out', user: null });
      });
    return () => {
      active = false;
    };
  }, [location.state]);

  return state;
};
